const localStorageUserKey = `${window.location.hostname}_81handyman_user`;
const localStorageAdminKey = `${window.location.hostname}_81handyman_admin`;

console.log("***localStorageUserKey: ", localStorageUserKey);
console.log("***localStorageAdminKey: ", localStorageAdminKey);
console.log("***user = localStorage.getItem(localStorageUserKey):::", localStorage.getItem(localStorageUserKey));

export {localStorageUserKey, localStorageAdminKey};

console.log("abc0");